import { ModelBase } from '../../core/model/model-base';
import { PostalAddress } from './postal-address';

export class CreditInstitute extends ModelBase {
  constructor() {
    super();
    this.postalAddress = new PostalAddress();
  }

  cultureName: string;
  name: string;
  organizationNumber: string;
  postalAddress: PostalAddress;
}
